import { render } from "./AddLocationsForm.vue?vue&type=template&id=0f13ddd3"
import script from "./AddLocationsForm.vue?vue&type=script&lang=js"
export * from "./AddLocationsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__